import { render, staticRenderFns } from "./AppHighlight.vue?vue&type=template&id=24c959ea&"
import script from "./AppHighlight.vue?vue&type=script&lang=js&"
export * from "./AppHighlight.vue?vue&type=script&lang=js&"
import style0 from "./AppHighlight.vue?vue&type=style&index=0&id=24c959ea&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports